/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForActivityLogAzure extends models.GovernanceConfigurationBaseForActivityLog {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForActivityLogAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForActivityLogAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForActivityLogAzure>): GovernanceConfigurationForActivityLogAzure {
        let obj = Object.assign(new GovernanceConfigurationForActivityLogAzure(), model);
        GovernanceConfigurationForActivityLogAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForActivityLogAzure>): GovernanceConfigurationForActivityLogAzure {
        if (!model) return null;
        return GovernanceConfigurationForActivityLogAzure.newInstance(<GovernanceConfigurationForActivityLogAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForActivityLogAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForActivityLogAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForActivityLogAzure): boolean {
        if (models.GovernanceConfigurationBaseForActivityLog.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForActivityLogAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Group Name
     */
    resource_group: string;

    /**
     * Alert Rule Name
     */
    rule_name: string;

    /**
     * Action Group
     */
    action_group: string;

    /**
     * Specifies whether the trail is created in the current Region or in all Regions
     */
    is_subscription_scope: boolean;

}
